exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".systemStatus[data-v-00009e56]{width:188px;height:38px;border-radius:48px;background-color:#fff;border:1px solid #41aaaa;text-align:center}.systemStatus svg[data-v-00009e56]{position:relative;top:3px}.systemStatus span[data-v-00009e56]{font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif;font-size:.8125rem;color:#fff;line-height:38px;text-align:left;color:#3c464b;padding-left:4px}", ""]);

// exports
